import type { SessionUser } from '@smile/shared';

/**
 * Does the signed-in user hold this grant? The session carries the
 * Casbin-resolved list as `act:obj` strings — `write:/messages/*` — probed
 * server-side for a fixed set of objects, so the UI can hide a button it
 * would otherwise show and watch fail. The server is still the authority.
 */
export function can(me: SessionUser | null | undefined, obj: string, act: 'read' | 'write'): boolean {
  if (!me) return false;
  return me.permissions.includes(`${act}:${obj}`);
}
